<ngb-accordion
  #acc="ngbAccordion"
  [destroyOnHide]="false"
  *ngFor="let attr of attrs; let index = index; trackBy: trackBy"
>
  <ngb-panel
    id="attr-{{ index }}"
    *ngIf="attr.data?.count > 0 || (attr.custom && attr.data)"
    [ngClass]="{ disabled: attr.featureDisabled }"
    [disabled]="attr.featureDisabled"
  >
    <ng-template ngbPanelTitle="ngbPanelTitle">
      <div class="card-title-content">
        <i
          class="card-title-content__icon glyphicon glyphicon-ab-plus"
          [ngClass]="{ 'is-opened': acc.isExpanded('attr-' + index) }"
        ></i
        ><span class="card-title-content__no-shrink text-truncate">{{
          attr.heading
        }}</span
        ><span class="card-title-content__count">{{ attr.data.count }}</span
        ><span
          class="card-title-content__small card-title-content__value text-truncate"
          *ngIf="attr.data.attributes && attr.data.attributes[0].value"
          >{{ attr.data.attributes[0].value | attrValue: attr.key }}</span
        ><span
          class="card-title-content__small card-title-content__count"
          *ngIf="attr.data.attributes && attr.data.attributes[0].value"
          >&middot;</span
        ><span
          class="card-title-content__small"
          *ngIf="attr.data.attributes && attr.data.attributes[0].value"
          >{{ attr.data.attributes[0].percentile }}%</span
        ><i
          class="pinned-item glyphicon"
          title="Unpin this aggregation"
          *ngIf="attr.custom"
          (click)="deleteAttr($event, attr)"
          [ngClass]="isHovered ? 'glyphicon-ab-pin-remove' : 'glyphicon-ab-pin'"
          (mouseenter)="isHovered = true"
          (mouseleave)="isHovered = false"
        ></i>
      </div>
    </ng-template>
    <div class="loading-overlay" [hidden]="!attr.loading"></div>
    <ng-template ngbPanelContent="ngbPanelContent">
      <table
        class="ab-table ab-table--wide-first-cell"
        [hidden]="attr.data.attributes?.length === 0"
      >
        <thead *ngIf="attr.data.attributes">
          <th class="ab-table__header">
            {{ attr.key | attrKeyLastField | upperCaseSplit }}
          </th>
          <th class="ab-table__header">
            <a
              class="th-link"
              (click)="attr.load('notice_count')"
              [ngClass]="{ 'th-link--disabled': attr.sorting }"
              >Count<span
                [hidden]="
                  attr.sorting || attr.params.order !== 'notice_count ASC'
                "
                ><i
                  class="glyphicon glyphicon-caret-up th-link__icon"
                ></i></span
              ><span
                [hidden]="
                  attr.sorting || attr.params.order !== 'notice_count DESC'
                "
                ><i
                  class="glyphicon glyphicon-caret-down th-link__icon"
                ></i></span
              ><span
                class="th-link__icon"
                [hidden]="!attr.sorting || attr.column !== 'notice_count'"
              >
                <ab-spinner-inline></ab-spinner-inline></span
            ></a>
          </th>
          <th class="ab-table__header">
            <a
              class="th-link"
              (click)="attr.load('first_seen_at')"
              [ngClass]="{ 'th-link--disabled': attr.sorting }"
              >First seen<span
                [hidden]="
                  attr.sorting || attr.params.order !== 'first_seen_at ASC'
                "
                ><i
                  class="glyphicon glyphicon-caret-up th-link__icon"
                ></i></span
              ><span
                [hidden]="
                  attr.sorting || attr.params.order !== 'first_seen_at DESC'
                "
                ><i
                  class="glyphicon glyphicon-caret-down th-link__icon"
                ></i></span
              ><span
                class="th-link__icon"
                [hidden]="!attr.sorting || attr.column !== 'first_seen_at'"
              >
                <ab-spinner-inline></ab-spinner-inline></span
            ></a>
          </th>
          <th class="ab-table__header">
            <a
              class="th-link"
              (click)="attr.load('last_seen_at')"
              [ngClass]="{ 'th-link--disabled': attr.sorting }"
              >Last seen<span
                [hidden]="
                  attr.sorting || attr.params.order !== 'last_seen_at ASC'
                "
                ><i
                  class="glyphicon glyphicon-caret-up th-link__icon"
                ></i></span
              ><span
                [hidden]="
                  attr.sorting || attr.params.order !== 'last_seen_at DESC'
                "
                ><i
                  class="glyphicon glyphicon-caret-down th-link__icon"
                ></i></span
              ><span
                class="th-link__icon"
                [hidden]="!attr.sorting || attr.column !== 'last_seen_at'"
              >
                <ab-spinner-inline></ab-spinner-inline></span
            ></a>
          </th>
        </thead>
        <tbody *ngIf="attr.data.attributes">
          <tr
            class="ab-table__row"
            *ngFor="let item of attr.data.attributes; trackBy: trackById"
            [ngSwitch]="attr.key"
          >
            <td class="ab-table__cell">
              <span *ngSwitchCase="'errors.0.stackRecord'"
                >{{ item.value | attrValue: attr.key }}:{{ item.value.line
                }}<span *ngIf="item.value.column > 0"
                  >:{{ item.value.column }}</span
                ><span *ngIf="item.value.function">
                  &nbsp; in {{ item.value.function }}</span
                ></span
              ><a
                *ngSwitchDefault
                [ngSwitch]="attr.key"
                uiSref="groups-show"
                [uiParams]="groupsShowParams(attr, item)"
                [uiOptions]="{ reload: true }"
                ><span *ngSwitchCase="'context.userAddr'"
                  >{{ item.value.userAddr }}
                  <ab-country
                    *ngIf="item.value.userCountry"
                    [country]="item.value.userCountry"
                    [code]="item.value.userCountryCode"
                  ></ab-country></span
                ><span *ngSwitchCase="'context.userCountry'">
                  <ab-country
                    *ngIf="item.value.userCountry"
                    [country]="item.value.userCountry"
                    [code]="item.value.userCountryCode"
                    [showUnknownCountry]="true"
                  ></ab-country></span
                ><span *ngSwitchCase="'context.remoteAddr'"
                  >{{ item.value.remoteAddr }}
                  <ab-country
                    *ngIf="item.value.remoteCountry"
                    [country]="item.value.remoteCountry"
                    [code]="item.value.remoteCountryCode"
                  ></ab-country></span
                ><span *ngSwitchCase="'context.remoteCountry'">
                  <ab-country
                    *ngIf="item.value.remoteCountry"
                    [country]="item.value.remoteCountry"
                    [code]="item.value.remoteCountryCode"
                    [showUnknownCountry]="true"
                  ></ab-country></span
                ><span *ngSwitchCase="'context.user'"
                  ><span *ngIf="item.value.id">#{{ item.value.id }}</span
                  >&nbsp;<span *ngIf="item.value.name">{{
                    item.value.name
                  }}</span
                  >&nbsp;<span *ngIf="item.value.username">{{
                    item.value.username
                  }}</span
                  >&nbsp;<span *ngIf="item.value.email">{{
                    item.value.email
                  }}</span></span
                ><span *ngSwitchCase="'context.browserName'">
                  <div
                    class="ab-user-agent {{
                      item.value.name.replace(' ', '-').toLowerCase()
                    }}"
                  >
                    {{ item.value.name }}
                  </div></span
                ><span *ngSwitchCase="'context.browser'">
                  <div
                    class="ab-user-agent {{
                      item.value.name.replace(' ', '-').toLowerCase()
                    }}"
                  >
                    {{ item.value.name }} {{ item.value.version }}
                  </div></span
                ><span *ngSwitchCase="'context.browserEngine'"
                  >{{ item.value.name }} {{ item.value.version }}</span
                ><span *ngSwitchCase="'context.browserPlatform'"
                  >{{ item.value.os }} {{ item.value.platform }}</span
                ><span *ngSwitchCase="'context.messageParams'">{{
                  item.value | json
                }}</span
                ><span *ngSwitchCase="'context.action'"
                  ><span *ngIf="item.value.component"
                    >{{ item.value.component }}#</span
                  >{{ item.value.action }}</span
                ><span *ngSwitchDefault>{{
                  item.value | attrValue: attr.key
                }}</span></a
              >
            </td>
            <td class="ab-table__cell">
              {{ item.noticeCount }}
              &nbsp;<span class="text-small">({{ item.percentile }}%)</span>
            </td>
            <td class="ab-table__cell">
              <a
                uiSref="notices-show"
                [uiParams]="{
                  noticeId: item.minNoticeId,
                  tab: 'notice-detail'
                }"
                >{{ item.firstSeenAt | date: "MMM dd, y HH:mm:ss Z" }}</a
              >
            </td>
            <td class="ab-table__cell">
              <a
                uiSref="notices-show"
                [uiParams]="{
                  noticeId: item.maxNoticeId,
                  tab: 'notice-detail'
                }"
                >{{ item.lastSeenAt | date: "MMM dd, y HH:mm:ss Z" }}</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p [hidden]="attr.data.attributes?.length > 0">
        The aggregation is being created. Check in 10 minutes.
      </p>
      <div
        class="d-flex mt-3 justify-content-center"
        *ngIf="showPagination(attr.data.count)"
      >
        <ngb-pagination
          [collectionSize]="attr.data.count"
          [pageSize]="pageSize"
          [boundaryLinks]="true"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="attr.params.page"
          (pageChange)="attr.loadNextPage()"
        >
          <ng-template ngbPaginationFirst="ngbPaginationFirst">«</ng-template>
          <ng-template ngbPaginationPrevious="ngbPaginationPrevious"
            >‹</ng-template
          >
          <ng-template ngbPaginationNext="ngbPaginationNext">›</ng-template>
          <ng-template ngbPaginationLast="ngbPaginationLast">»</ng-template>
        </ngb-pagination>
      </div>
    </ng-template>
  </ngb-panel>
</ngb-accordion>
